<template>
  <div>
    <!-- <div style="height:57px;" class="row comm-settings-top-nav">
      <div class="justify-content-start" style="width:90%;position:relative">
        <back-button v-if="componentname != 'show-bins'" v-on:click.native="changeToSelectedBinComponent('show-bins')" style="position: absolute;bottom: 19px;inset-inline-start:5px;"></back-button>
        <nav aria-label="breadcrumb">
          <ol class="breadcrumb comm-settings-top-nav m-0" style="padding-inline-start:4%">
            <li class="breadcrumb-item"><a v-on:click="changeToSelectedBinComponent('show-bins')">Bins</a></li>
            <li class="breadcrumb-item active-text-nav-bar" aria-current="page">{{selectedBinId}}</li>
            </ol>
        </nav>
      </div>
      <div class="p-0 primary-btn-style justify-content-end" STYLE="width:10%">
          <button type="button" class="btn btn-outline-primary" v-if="showAddBinButton" v-on:click="changeToSelectedBinComponent('add-bin')">Add</button>
      </div>
    </div> -->
  </div>
</template>

<script>
// import BackButton from "../core/backButton.vue";

export default {
    props : ["selectedBinId","showAddBinButton","componentname"],
    data(){
        return{
            add:"Add",
        }
    },
    methods:{
        changeToSelectedBinComponent(compName, payload = {}){
            this.$emit("changeToSelectedBinComponent", compName, payload)
        }
    },
     components:{
        // "back-button":BackButton
    },
}
</script>

<style scoped lang="scss">
    $border-color: 1px solid #4a4a4a;
    $border-color-only:#4a4a4a;
    $primary-background: #1a1e21;
    $secondary-background-color:#15181B;
    $bg-color-on-hover: #22272b;
    $text-color: #eee;
    $dull-text-color: #757575;
    $secondary-text-color: #9c9c9c;
    $active-blue : #007bff;
    $input-field-and-label-font-size:14px;
    $input-field-height:38px;
    $none-text-color:#4f4f4f;
    $input-field-padding:.375rem 10px;
    $scrollbar-thumb-background:#333;
    $scrollbar-track-background:#1a1e21;
    $scrollbar-thumb-on-hover-background:#555;
    $tags-background-color:#282d31;
    $tags-border-color:#363636;
    $metadata-border-color-on-hover: #5a5a5a;
    $secondary-border-color: 1px solid #2b2b2b;
    $active-green-color:#28a745;
    $svg-color:#666;
    $learn-about-text-color-hover:#b7b327;
    $active-green-icon-color: #00ff3a;
    $learn-about-text-color:#9a9620;

.comm-settings-top-nav{
    background: $primary-background !important;
}

.btn{
    font-size:14px !important;
    height:100%;
}

.breadcrumb{
  padding: .75rem 1rem !important;
    .active-text-nav-bar{
        color: $text-color !important;
        text-decoration: none !important
    }
    .active-text-nav-bar:last-child{
            color: $active-blue !important;
            font-size:17px;
    }
    .breadcrumb-item{
        a{
            color: $text-color;
            font-weight:600;
        }
        a:hover{
            text-decoration: underline;
        }
    }    
}



.primary-btn-style{
    margin-top:1%;
    button{
        height: 35px;
        width: 70px;
    font-size:14px;
    }
}
</style>